import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFlexiblePrecision, getFlexibleRange, getTaskColorClass } from './scheduleUtils';
import { getTaskScheduleLabel } from './taskScheduleLabel';
import { TimelineTaskModal } from './TimelineTaskModal';
import { sortPlannerTasks } from './taskListOrder';
import { PlannerTaskInfo } from './types';
import { useTimelineView } from './TimelineViewContext';

export const TimelineYearTaskBar: React.FC<{ year: number }> = ({ year }) => {
    const { t, i18n } = useTranslation();
    const { onDeleteTask, onEditTask, onToggleComplete, tasksWithDueDates } = useTimelineView();
    const [selectedTask, setSelectedTask] = useState<PlannerTaskInfo | null>(null);
    const tasks = sortPlannerTasks(tasksWithDueDates.filter(({ task }) => {
        if (getFlexiblePrecision(task) !== 'year') return false;
        const { start, end } = getFlexibleRange(task);
        return start.getFullYear() <= year && end.getFullYear() >= year;
    }));
    if (!tasks.length) return null;
    const visibleTasks = tasks.slice(0, 2);
    return <>
        <div className="timeline-year-task-bar" aria-label={t('dailyPlanner.allYear')}>
            <span>{t('dailyPlanner.allYear')}</span>
            {visibleTasks.map((taskInfo) => <button key={taskInfo.task.id} type="button"
                data-timeline-task-id={taskInfo.task.id}
                className={`${getTaskColorClass(taskInfo.task)} ${taskInfo.task.completed ? 'completed' : ''}`}
                onClick={() => setSelectedTask(taskInfo)}>
                {taskInfo.task.title}
            </button>)}
            {tasks.length > visibleTasks.length && <span className="timeline-year-task-more">+{tasks.length - visibleTasks.length}</span>}
        </div>
        {selectedTask && <TimelineTaskModal task={selectedTask.task} collectionId={selectedTask.collectionId}
            timeLabel={getTaskScheduleLabel(
                selectedTask.task, i18n.language, year, undefined, {
                    deadline: t('addTask.deadline'), startsAt: t('dailyPlanner.startsAt'),
                    startsIn: t('dailyPlanner.startsIn'), startsOn: t('dailyPlanner.startsOn'),
                }
            )} onClose={() => setSelectedTask(null)}
            onDelete={onDeleteTask} onEdit={onEditTask} onToggleComplete={onToggleComplete} />}
    </>;
};
